// tslint:disable max-line-length
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { useParams } from 'react-router-dom';
import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import SuggestedTrainingVideoList from './SuggestedTrainingVideoList';
import { fetchLearningModule } from '../../requests/learning';
import { prepareSingleModuleResponseData } from './Standards.utils';
import { setProfilePoint } from '../../requests/profilepic';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { Loading } from '../../app/common/icons/Loading';

const Wrapper = styled.div`
`;

const Content = styled.div<{ isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  top:60px;
  position:relative;
  opacity: ${props => props.isVisible ? 1 : 0};
  transition: opacity 0.5s ease-in;
`;

const VideoInformation = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 26px 18px 13px;
  .module {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #4FADA6;
    margin: 5px 0 7px;
    text-transform: uppercase;
  }
  .label {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 19px;
    color: #071C3E;
    margin-bottom: 8px;
  }
  .text{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    color: #1F1F1F;
  }
`;

const VideoSuggerences = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

const VideoSection = styled.div`
  .rh5v-DefaultPlayer_component {
    height: 281px;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const TrainingVideoVisualizer = () => {
  const { t } = useTranslation();
  const [videoData, setVideoData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isContentVisible, setIsContentVisible] = useState<boolean>(false);
  const {id: moduleId} = useParams();
  let stopProgressbar = false;
  useEffect(() => {
    (async () => {
      setVideoData(null);
      setIsLoading(true);
      setIsContentVisible(false);
      const {data} = await fetchLearningModule(moduleId);
      const preparedData = prepareSingleModuleResponseData({...data.data, suggestions: data.suggestions});
      setVideoData(preparedData);
      setIsLoading(false);
      // Trigger fade-in animation for content
      setTimeout(() => {
        setIsContentVisible(true);
      }, 10); // Small delay to ensure DOM is ready
    })();
  }, [moduleId]);
  const handleProgress = (e) => {
    if (isNaN(e.target.duration)) {
      return;
    }
    const progress = (e.target.currentTime / e.target.duration) * 100;

    if (progress >= 80 && !stopProgressbar) {
      const data = {
        entityId: videoData.id,
        entityType: 'Video',
        activityType: 'VideoPoint',
      };
      stopProgressbar = true;
      setProfilePoint(data)
        .then((res) => {
        })
        .catch((err) => (stopProgressbar = false));
    }
  };

  const frontendDescriptions = [
    {
      id: 1,
      module_id: 21,
      title: 'Grooming and Uniform',
      description: 'LOOK SHARP! Be well-groomed and neatly presented in clean, well fitted uniforms, including name badges (if applicable) to make a positive first impression',
    },
    {
      id: 2,
      module_id: 22,
      title: 'Clear Speech and satisfactory English',
      description: 'CLARITY MATTERS! Use clear speech and satisfactory English to engage in two-way conversation with the guest',
    },
    {
      id: 3,
      module_id: 23,
      title: 'Show Genuine Interest',
      description: 'REAL TALK! Engage in a well-paced, natural (non-scripted, jargon/slang free), friendly and interested manner',
    },
    {
      id: 4,
      module_id: 24,
      title: 'Name Usage',
      description: 'SHOW YOU KNOW ME! Use the guest\'s name naturally and discreetly, without overusing it',
    },
    {
      id: 5,
      module_id: 25,
      title: 'Confidence and Knowledge',
      description: 'KNOW OR FIND OUT! Show a high level of confidence when carrying out your duties and be knowledgeable when answering questions about other hotel facilities, or immediately offer to find out the information required',
    },
    {
      id: 6,
      module_id: 26,
      title: 'Anticipation and Intuition',
      description: 'ACT BEFOR THEY ASK! Provide anticipatory/intuitive service and think ahead to act on the guest\'s future needs or opportunities',
    },
    {
      id: 7,
      module_id: 27,
      title: 'Adapting to Change',
      description: 'THINK ON YOUR FEET! Adapt to a changing situation and/or guest\'s needs',
    },
    {
      id: 8,
      module_id: 28,
      title: 'Meetings a guest\'s requests',
      description: 'NEVER SAY (A FAST) NO! Make every effort to meet the guest\'s requests or offer a suitable alternative',
    },
    {
      id: 9,
      module_id: 29,
      title: 'Personalization',
      description: 'CAST FOOR A CONNECTION! Personalize the interaction and engage with the guest as an individual',
    },
    {
      id: 10,
      module_id: 30,
      title: 'Seamless Service',
      description: 'NO I TEAM! Collaborate seamlessly to ensure service is organized and professional; not intrusive or repetitive',
    },
    {
      id: 11,
      module_id: 31,
      title: 'Active Listening',
      description: 'TUNE IN! Listen actively, avoid interrupting and give the guest your undivided attention',
    },
    {
      id: 12,
      module_id: 32,
      title: 'Alert Postures',
      description: 'LIFE GUARD\'S LOOKOUT! Maintain an alert posture and respect the guest\'s presence when interacting with each other',
    },
    {
      id: 13,
      module_id: 33,
      title: 'Empathy and Self control',
      description: 'FEEL MY FEELINGS, KEEP YOUR COOL! In challenging interactions, display self-control and empathy, and offer a suitable alternative/resolution',
    },
  ];
  
  function getDescriptionsByModule (videoDataId, data) {
    const item = data.find(object => object.module_id === videoDataId);
    
    if (!item) {
      return null;
    }
  
    return item.description;
  }

  return (
    <Wrapper>
      <div className="header">
        <AppHeader title={t('COMMON.LEARNING.TITLES.EI_BEHAVIORAL')} hasBackButton={true} />
      </div>
      { isLoading || !videoData ? (
          <SpinnerWrapper>
            <Loading size="xl" color="primary" />
          </SpinnerWrapper>
      ) :
        <Content isVisible={isContentVisible}>
          <VideoSection>
          <Video
            className="my-video"
            height={281}
            controls={['PlayPause', 'Time', 'Volume', 'Fullscreen']}
            poster={videoData.pictureUrl}
            src={videoData.videoUrl}
            type="video/mp4"
            onTimeUpdate={handleProgress}
          />            
          </VideoSection>
          <VideoInformation>
            <div className="module">
              {videoData.module}
            </div>
            <div className="label">
              {videoData.label}
            </div>
            <div className="text">
              {videoData.id ? getDescriptionsByModule(videoData.id, frontendDescriptions) || 'Let LQA walk you through the newest requirements of setting expectations and reservations with the highest standards and best customer experience. ' : 'Let LQA walk you through the newest requirements of setting expectations and reservations with the highest standards and best customer experience.'}
            </div>
          </VideoInformation>
          <VideoSuggerences>
          <SuggestedTrainingVideoList module={videoData.module} data={videoData.suggestions} />
          </VideoSuggerences>
        </Content>
      }
    </Wrapper>
  );
};

export default TrainingVideoVisualizer;
